import React, { Component } from "react";
import { connect } from "react-redux";
import { Table, Card, Form, Button, Input, message, Select, Modal } from "antd";
import PropTypes from "prop-types";
import { usrRole } from "../../utils/dataUtil";
import {
  req_del_pim_staff_overtime_offset,
  req_add_pim_staff_overtime_offset,
  req_list_pim_staff_overtime_offset,
} from "../../api";
const { TextArea } = Input;
class OvertimeMonthOffsetModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    data: PropTypes.object.isRequired,
  };

  state = {
    item: {},
    modify: true,
    loading: false,
    lock: false,
    userLevel: "NORMAL",
    searchField: "None",
    searchValue: "",
    setOffsetType: "TIME",
    setOffsetMinutes: 0,
    setRecordDescription: "",
  };

  componentDidMount() {
    this.api_item_list();
  }

  ////////////////////////////////////////////////////////////
  api_item_list = async () => {
    //console.log( this.props.data)
    const { searchField, searchValue } = this.state;
    const { token, role, userCode } = this.props.user;
    const { StaffCode, OverTimeMonth } = this.props.data;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel, loading: true });
    const result = await req_list_pim_staff_overtime_offset(
      userLevel,
      userCode,
      OverTimeMonth,
      StaffCode,
      searchField,
      searchValue,
      token
    );
    if (result.total > 0) {
      const items = result.data;
      this.setState({
        data: items,
        loading: false,
      });
    } else {
      const items = [];
      this.setState({
        data: items,
        loading: false,
      });
    }
  };

  api_add_item = async () => {
    const { setOffsetType, setOffsetMinutes, setRecordDescription } =
      this.state;
    const { StaffCode, OverTimeMonth } = this.props.data;
    const { token } = this.props.user;
    const item = {
      StaffCode: StaffCode,
      YearMonth: OverTimeMonth,
      OffsetType: setOffsetType,
      OffsetMinutes: setOffsetMinutes,
      RecordDescription: setRecordDescription,
    };
    const result = await req_add_pim_staff_overtime_offset(item, token);
    if (result.status === "success") {
      message.success(result.message);
      this.api_item_list();
    } else {
      this.setState({ loading: false });
      message.error(result.message);
    }
  };

  api_detete_item = async (item) => {
    const { Uid } = item;
    const { token } = this.props.user;

    const result = await req_del_pim_staff_overtime_offset(Uid, token);
    if (result.status === "success") {
      message.success(result.message);
      this.api_item_list();
    } else {
      message.error(result.message);
    }
  };

  ///////////////////////////////////////////////////////////
  onFinish = async (values) => {
    //console.log("data:", values);
    this.setState({ loading: true });
    this.setState({ setOffsetMinutes: values.setOffsetMinutes });
    await this.api_add_item();
  };

  ///////////////////////////////////////////////////////////
  handleSelectChange = (value) => {
    this.setState({ setOffsetType: value });
  };

  handleTextAreaChange = (e) => {
    console.log(e.target.value);
    this.setState({ setRecordDescription: e.target.value });
  };

  handle_btn_event = (type, item) => {
    switch (type) {
      case "delete":
        const { Uid } = item;
        Modal.confirm({
          title: `您確定註銷此筆資料嗎?`,
          onOk: () => {
            console.log(item);
            const row = {
              Uid: Uid,
            };
            this.api_detete_item(row);
          },
        });
        break;
      default:
        return;
    }
  };

  render() {
    const { data, loading, setOffsetMinutes } = this.state;
    const columns = [
      {
        title: "操作",
        width: "100px",
        align: "center",
        render: (item) => {
          return (
            <div>
              <button
                className="btn btn-outline-dark btn-sm"
                onClick={() => this.handle_btn_event("delete", item)}
              >
                <i className="fas fa-minus"></i> 刪除
              </button>
            </div>
          );
        },
      },
      {
        title: "抵銷方式",
        dataIndex: "OffsetType",
        key: "OffsetType",
        render: (text) => <>{text === "TIME" ? "補休" : "經費"}</>,
      },
      {
        title: "抵銷分鐘",
        dataIndex: "OffsetMinutes",
        key: "OffsetMinutes",
      },
      {
        title: "抵銷說明",
        dataIndex: "RecordDescription",
        key: "RecordDescription",
      },
    ];
    const title = <>抵扣年月：{this.props.data.OverTimeMonth} | 姓名：{this.props.data.StaffName}</>;
    return (
      <Card title={title}>
        <Form onFinish={this.onFinish}>
          <Form.Item label="抵銷方式">
            <Select defaultValue="TIME" onChange={this.handleSelectChange}>
              <Select.Option value="TIME">補休</Select.Option>
              <Select.Option value="MONEY">經費</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item
            label="抵銷分鐘"
            name="setOffsetMinutes"
            initialValue={setOffsetMinutes}
          >
            <Input placeholder="抵銷分鐘" />
          </Form.Item>
          <Form.Item label="抵銷說明">
            <TextArea rows={2} onChange={this.handleTextAreaChange} placeholder="OO月OO日請補休(或領津貼)，扣抵XX月份共1小時"/>
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" style={{ width: "100%" }}>
              送出
            </Button>
          </Form.Item>
        </Form>
        <Table
          bordered
          columns={columns}
          dataSource={data}
          pagination={false}
          loading={loading}
          scroll={{
            y: 55 * 5,
          }}
        />
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(OvertimeMonthOffsetModal);
